export default "__VITE_ASSET__35e3f6a8__"